import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Version from "../../components/Version";
import useWindowDimensions from "../../helpers/Hooks/useWindowDimensions";
import { devEnv, routes } from "../../helpers/Routes";
import NinjaEdgeLogo from "../../assets/NinjaLogoSVG.svg";

const Home = () => {
  const navigate = useNavigate();
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    setTimeout(() => {
      navigate(routes.apply);
    }, 2000);
  }, []);

  return (
    <>
      <main
        className="h-full flex flex-col flex-grow items-center justify-center text-blackText"
        style={{ height: `${height - 8}px` }}
      >
        <img className="w-52 h-6" src={NinjaEdgeLogo} />

        {devEnv === "production" ? (
          <>
            <div className="my-4 text-lg font-semibold">
              CX / UX visualization
            </div>
            {/* <div className="underline text-sm cursor-pointer" onClick={() => navigate(routes.apply)}>
              Apply for Credit
            </div> */}
          </>
        ) : (
          <>
            <div className="p-2" onClick={() => navigate(routes.apply)}>
              Start from Apply Page
            </div>
            <div className="p-2" onClick={() => navigate(routes.otp)}>
              OTP
            </div>
            <div className="p-2" onClick={() => navigate(routes.apply)}>
              Apply for credit
            </div>
            <div
              className="p-2"
              onClick={() => navigate(routes.customerPortal)}
            >
              Customer Portal
            </div>
            <div className="p-2" onClick={() => navigate(routes.connectBank)}>
              ConnectBank
            </div>
            <div className="p-2" onClick={() => navigate(routes.login)}>
              Login
            </div>
          </>
        )}
      </main>
      {/* <Version /> */}
    </>
  );
};

export default Home;
